import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function replace(location) {
  return originalPush.call(this, location).catch(err => err)
}

const home = ()=>import('views/home/home.vue')
const mods = ()=>import('views/mods/mods.vue')

const mats = ()=>import('views/mats/mats.vue')

const maps = ()=>import('views/maps/maps.vue')

const dseek = ()=>import('views/seek/dseek.vue')
const tseek = ()=>import('views/seek/tseek.vue')
const pseek = ()=>import('views/seek/pseek.vue')
const sseek = ()=>import('views/seek/sseek.vue')
const news = ()=>import('views/news/news.vue')
const new_p = ()=>import('views/news/new_p.vue')
const special_p = ()=>import('views/news/special_p.vue')
const details = ()=>import('views/details/details.vue')
const about = ()=>import('views/about/about.vue')
const register = ()=>import('views/register/register.vue')

const users = ()=>import('views/users/users.vue')
const user = ()=>import('views/users/childcomps/user.vue')
const upload = ()=>import('views/users/childcomps/upload.vue')
const support = ()=>import('views/users/childcomps/support.vue')
const suplist = ()=>import('views/users/childcomps/suplist.vue')
const ifriend = ()=>import('views/users/childcomps/ifriend.vue')

const cabout = ()=>import('views/about/childcomps/about.vue')
const statement = ()=>import('views/about/childcomps/statement.vue')
const useruploadxy = ()=>import('views/about/childcomps/useruploadxy.vue')
const download = ()=>import('views/about/childcomps/download.vue')
const help = ()=>import('views/about/childcomps/help.vue')
const question = ()=>import('views/about/childcomps/question.vue')

const routes = [
  {
    path:'/',
    redirect: '/home'
  },
  {
    path:'/home',
    name:'Home',
    component:home,
    meta:{
      title:'首页',
      keepAlive:true,
      scrollTop:0,
      scrollelename:'#home',
    }
  },
  {
    path:'/register',
    name:'Register',
    component:register,
    meta:{
      title:'邀请注册页',
      keepAlive:false
    }
  },
  {
    path:'/mods',
    name:'Mods',
    component:mods,
    meta:{
      title:'模型',
      keepAlive:false,
      scrollTop:0,
      scrollelename:'#mods',
      lasturl:'',
    },
    beforeEnter:(to,from,next)=>{
      if(store.state.lastroutepaths.mods != ''){
        next(store.state.lastroutepaths.mods)
      }else{
        next()
      }
    }
  },
  {
    path:'/mats',
    name:'Mats',
    component:mats,
    meta:{
      title:'材质',
      keepAlive:false,
      scrollTop:0,
      scrollelename:'#mats',
      lasturl:'',
    },
    beforeEnter:(to,from,next)=>{
      if(store.state.lastroutepaths.mats != ''){
        next(store.state.lastroutepaths.mats)
      }else{
        next()
      }
    }
  },
  {
    path:'/maps',
    name:'Maps',
    component:maps,
    meta:{
      title:'贴图',
      keepAlive:false,
      scrollTop:0,
      scrollelename:'#maps',
      lasturl:'',
    },
    beforeEnter:(to,from,next)=>{
      if(store.state.lastroutepaths.maps != ''){
        next(store.state.lastroutepaths.maps)
      }else{
        next()
      }
    }
  },
  {
    path:'/dseek',
    name:'Dseek',
    component:dseek,
    meta:{
      title:'模型列表',
      keepAlive:true,
      scrollTop:0,
      scrollelename:'#dseek',
    }
  },
  {
    path:'/tseek',
    name:'Tseek',
    component:tseek,
    meta:{
      title:'材质列表',
      keepAlive:true,
      scrollTop:0,
      scrollelename:'#tseek',
    }
  },
  {
    path:'/pseek',
    name:'Pseek',
    component:pseek,
    meta:{
      title:'贴图列表',
      keepAlive:true,
      scrollTop:0,
      scrollelename:'#pseek',
    }
  },
  {
    path:'/sseek',
    name:'Sseek',
    component:sseek,
    meta:{
      title:'搜索列表',
      keepAlive:false
    }
  },
  {
    path:'/news', // 主题列表页
    name:'News',
    component:news,
    meta:{
      title:'主题列表',
      keepAlive:true,
      scrollTop:0,
      scrollelename:'#news',
    }
  },
  {
    path:'/new_p', //新闻单页 具体页 未制作
    name:'New_p',
    component:new_p,
    meta:{
      title:'新闻单页',
      keepAlive:false
    }
  },
  {
    path:'/special_p', // 主题单页 具体页
    name:'Special_p',
    component:special_p,
    meta:{
      title:'主题单页',
      keepAlive:false
    }
  },
  {
    path:'/details', //大图页
    name:'Details',
    component:details,
    meta:{
      title:'大图页',
      keepAlive:false
    }
  },
  {
    path:'/about', //关于我们
    name:'About',
    component:about,
    meta:{
      title:'关于我们',
      keepAlive:false,
    },
    redirect:'/about/about',
    children: [{
      path: '/about/about',
      name: 'Cabout',
      component: cabout,
      meta:{
        title:'我们',
        keepAlive:false
      }
    },
    {
      path: '/about/statement',
      name: 'Statement',
      component: statement,
      meta:{
        title:'版权声明',
        keepAlive:false
      }
    },
    {
      path: '/about/useruploadxy',
      name: 'Useruploadxy',
      component: useruploadxy,
      meta:{
        title:'用户上传协议',
        keepAlive:false
      }
    },
    {
      path: '/about/download',
      name: 'Download',
      component: download,
      meta:{
        title:'下载',
        keepAlive:false
      }
    },
    {
      path: '/about/help',
      name: 'Help',
      component: help,
      meta:{
        title:'使用说明',
        keepAlive:false
      }
    },{
      path:'/about/question',
      name: 'Question',
      component: question,
      meta:{
        title:'问题',
        keepAlive:false
      }
    }]
  },
  {
    path:'/users', //用户页
    name:'Users',
    component:users,
    meta:{
      title:'用户页',
      keepAlive:false,
    },
    redirect:'/users/user',
    children: [{
      path: '/users/user',
      name: 'User',
      component: user,
      meta:{
        title:'个人资料',
        keepAlive:false
      }
    },
    {
      path: '/users/upload',
      name: 'Upload',
      component: upload,
      meta:{
        title:'上传管理',
        keepAlive:false
      }
    },
    {
      path: '/users/support',
      name: 'Support',
      component: support,
      meta:{
        title:'支持我们',
        keepAlive:false
      }
    },
    {
      path: '/users/suplist',
      name: 'Suplist',
      component: suplist,
      meta:{
        title:'支持列表',
        keepAlive:false
      }
    },
    {
      path: '/users/ifriend',
      name: 'Ifriend',
      component: ifriend,
      meta:{
        title:'邀请好友',
        keepAlive:false
      }
    }]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
